import i18n from '_/i18n';
import {showSimpleConfirmationDialog} from '_/sharedComponents/ConfirmationDialog';

export enum PendingUploadTriggers {
  LOGOUT = 'logout',
  CLOSE = 'close',
  RELOAD = 'reload',
  UPDATE = 'update',
}

export const showPendingUploadsConfirmationDialog = ({
  trigger,
  numberOfPendingFiles,
  numberOfFailedFiles,
  proceed,
}: {
  trigger: PendingUploadTriggers;
  numberOfPendingFiles: number;
  numberOfFailedFiles: number;
  proceed: () => Promise<void> | void;
}): void => {
  const texts = [];
  if (numberOfPendingFiles > 0) {
    texts.push(
      i18n.t('documents:PendingUploadsConfirmationDialog.pendingFiles', {
        count: numberOfPendingFiles,
      })
    );
  }
  if (numberOfFailedFiles > 0) {
    texts.push(
      i18n.t('documents:PendingUploadsConfirmationDialog.failedFiles', {
        count: numberOfFailedFiles,
      })
    );
  }
  switch (trigger) {
    case PendingUploadTriggers.CLOSE:
      texts.push(i18n.t('documents:PendingUploadsConfirmationDialog.close'));
      break;
    case PendingUploadTriggers.LOGOUT:
      texts.push(i18n.t('documents:PendingUploadsConfirmationDialog.logout'));
      break;
    case PendingUploadTriggers.RELOAD:
      texts.push(i18n.t('documents:PendingUploadsConfirmationDialog.reload'));
      break;
  }

  showSimpleConfirmationDialog({
    message: texts.join(' '),
    buttonProps: {
      danger: true,
    },
    onConfirmed: proceed,
  });
};
